import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {xcService} from "_services/xcService";
import {RightOutlined} from "@ant-design/icons";
import {Select, Table} from "antd";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function ResponsesView({user}) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const userStorage = JSON.parse(storage.getItem(variables.USER));
    const [userData,setUserData] = useState(user??userStorage)
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const [years, setYears] = useState([]);
    const [yearActual, setYearActual] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);

    useEffect(() => {
        xcService.get(`/v1/years`).then(({data}) => {


            let mYears = [];
            data.data.map(it => {
                mYears.push({
                    value: it.year,
                    label: "20" + it.year + "/20" + (+it.year + 1),
                },)
            })
            setYears(mYears)

            let mActual = data.data.filter(it => it.old === false);
            if (mActual && mActual[0]) {
                setYearActual(mActual[0].year)
            } else {
                setYearActual(22)
            }
        })
        xcService.getToken(`/v1${userType !== "STUDENT" ? '/tutor' : ''}/questionnaireno/informes/${userData.uid}`)
            .then(({data}) =>
                data.data.filter(data => data.count === data.numberOfQuestions))
            .then((data) =>
                data.map(data => {
                    return {
                        ...data,
                        name: `${data.name.replace(t("datos.cuestionde"),'')}`,
                        year: `${data.year}/${data.year + 1}`,
                        years: data.year,
                        view: <a className={"btn-icon-text"} target={"_blank"} href={'/admin/responses/' + data.code + '?'+'user='+userData.uid+ '&year=' + data.year}>
                            <span>{t('informes.tableViewResponsesColHeading')}</span>
                            <RightOutlined/>
                        </a>
                    }
                }))
            .then(data => setData(data))
    }, [t])

    const columns = [
        {
            title: t('informes.tableReportColHeadingQ'),
            dataIndex: 'name',
            render: (text) => <p className={"text-data text-data--visibility"}>{text}</p>,
        },
        {
            title: t('informes.tableYearColHeading'),
            dataIndex: 'year',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
        },
        {
            title: t('informes.tableCourseColHeading'),
            dataIndex: 'course',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
        },
        {
            title: '',
            dataIndex: 'view',
            render: (text) => <div className={"text-show-data text-data--visibility"}>{text}</div>,
        },
    ];

    const handleChange = (value) => {
        setYearActual(value)
    };

    return <>
        <p>{t("filtraporyear")} <Select
            value={yearActual}
            style={{width: 120}}
            onChange={handleChange}
            options={years}
        /></p>
        <Table
            className={"table-informes"}
            pagination={{position: ['bottomCenter']}}
            rowKey={"name"}
            columns={columns}
            dataSource={data.filter(it => it.years === yearActual)}
        />

    </>
}

export default ResponsesView;
